import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';

import { Layout } from 'features/layout/Layout';
import theme from 'theme';
import './App.css';
import AppRoutes from 'routes/AppRoutes';
import { AuthProvider } from 'lib/auth';
import { config } from 'config';
import { LoadingScreen } from 'components/LoadingScreen';
import { AppContextProvider } from 'AppContextProvider';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider 
          oidcSettings={config.oidcSettings}
          defaultAuthorizedRouteRedirect="/login"
          loadingComponentFactory={() => <LoadingScreen title="Loading..." />}>
            <AppContextProvider>
              <Layout>
                <AppRoutes />
              </Layout>
            </AppContextProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
